import React from 'react';
import Rating, { IconContainerProps } from '@material-ui/lab/Rating';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@material-ui/icons/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@material-ui/icons/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core';
import { useAnalytics } from '@backstage/core-plugin-api';

const icons: { [index: string]: { icon: React.ReactElement; label: string } } =
  {
    1: {
      icon: <SentimentVeryDissatisfiedIcon />,
      label: 'No',
    },
    2: {
      icon: <SentimentDissatisfiedIcon />,
      label: 'Barely',
    },
    3: {
      icon: <SentimentSatisfiedIcon />,
      label: 'Somewhat',
    },
    4: {
      icon: <SentimentSatisfiedAltIcon />,
      label: 'Yes',
    },
    5: {
      icon: <SentimentVerySatisfiedIcon />,
      label: 'Extremely',
    },
  };

const useStyles = makeStyles({
  root: {
    borderColor: 'transparent',
    width: 200,
    display: 'flex',
    alignItems: 'center',
  },
});

const IconContainer = (props: IconContainerProps) => {
  const { value, ...other } = props;
  return <span {...other}>{icons[value].icon}</span>;
};

export const PageRating = () => {
  const [score, setScore] = React.useState<number | null>(0);
  const [hover, setHover] = React.useState(-1);
  const label = score !== null && icons[hover !== -1 ? hover : score]?.label;
  const classes = useStyles();
  const analytics = useAnalytics();
  return (
    <div>
      <Box component="fieldset" mb={3} className={classes.root}>
        <Typography variant="body2" component="legend">
          <strong>Is this page helpful?</strong>
        </Typography>
        <Rating
          name="customized-icons"
          getLabelText={(score: number) => icons[score].label}
          IconContainerComponent={IconContainer}
          value={score}
          onChange={(_, newScore) => {
            setScore(newScore);
            analytics.captureEvent('click', 'page rating', {
              attributes: { pageRatingScore: Number(newScore) },
            });
          }}
          onChangeActive={(_, newHover) => {
            setHover(newHover);
          }}
        />
        <Box ml={1}>
          <Typography variant="body2">{label}</Typography>
        </Box>
      </Box>
    </div>
  );
};
